export default {
    'errors.notAuthenticated':
        'Du har inte behörighet att utföra den här åtgärden.',
    'errors.forbidden': 'Du har inte tillstånd att utföra den här åtgärden',
    'errors.somethingWentWrong':
        'Något gick fel. Vänligen ladda om sidan eller kontakta Binosight.',
};
